import React, { Component } from "react";
import Paper from "material-ui-next/Paper";
import Big from 'big.js';
import moment from "moment";
import {
  Page,
  Loadable,
  DataTable,
  ViewDocumentButton,
  CurrencyValue,
  InfoTooltip
} from "components/support";
import { Row, Col } from "react-flexbox-grid";
import { CashRegisterRepository } from "core/repository";
import Typography from "material-ui-next/Typography";
import Filter from "./filter";

const parseDateTime = datetime => {
  const momentDatetime = new moment(datetime)
  return momentDatetime.isValid() && momentDatetime.format("DD/MM/YYYY hh:mm")
}

const parseMoney = money => {
  const parsedValue = (money.value/100)
    .toFixed(2)
    .replace(/\.(?=[^.]*$)/, ',')

  return `R$ ${parsedValue}`
}

const config = {
  identifier: "uuid",
  columns: [
    {
      accessor: "opening_date",
      type: "datetime",
      align: "center",
      Header: "Abertura",
      Cell: ({value}) => <span title={parseDateTime(value)}>{parseDateTime(value)}</span>
    },
    {
      accessor: "close_date",
      type: "datetime",
      align: "center",
      Header: "Fechamento",
      Cell: ({value}) => <span title={parseDateTime(value)}>{parseDateTime(value)}</span>
    },
    {
      accessor: "open_user.name",
      align: "center",
      Header: "Usuário",
      sortable: false,
      Cell: ({value}) => <span title={value}>{value}</span>
    },
    {
      accessor: "device.name",
      align: "center",
      Header: "Dispositivo",
      sortable: false,
      Cell: ({value}) => <span title={value}>{value}</span>
    },
    {
      id: "money_sales",
      accessor: cashRegister => cashRegister.moneySales(),
      align: "right",
      Header: (
        <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
          Vendas
          <InfoTooltip hint="Apenas vendas em dinheiro" />
        </span>
      ),
      type: "money",
      sortable: false,
      Cell: ({value}) => (
        <span title={parseMoney({value})}>
          <CurrencyValue value={Big(value)} type="money" />
        </span>
      )
    },
    {
      id: "additions",
      accessor: cashRegister => cashRegister.additions(),
      align: "right",
      Header: "Adições",
      type: "money",
      sortable: false,
      Cell: ({value}) => (
        <span title={parseMoney({value})}>
          <CurrencyValue value={Big(value)} type="money" />
        </span>
      )
    },
    {
      id: "withdrawals",
      accessor: cashRegister => cashRegister.withdrawals(),
      align: "right",
      Header: "Retiradas",
      type: "money",
      sortable: false,
      Cell: ({value}) => (
        <span title={parseMoney({value})}>
          <CurrencyValue value={Big(value)} type="money" />
        </span>
      )
    },
    {
      id: "totalMoney",
      accessor: cashRegister => cashRegister.totalMoney(),
      align: "right",
      Header: "Total",
      type: "money",
      sortable: false,
      Cell: ({value}) => (
        <span title={parseMoney({value})}>
          <CurrencyValue value={Big(value)} type="money" />
        </span>
      )
    },
    {
      Header: "Ações",
      Cell: props => {
        return (
          <Row middle="xs" center="xs">
            <Col xs={6} className="pr-0">
              <ViewDocumentButton
                repository={CashRegisterRepository}
                document={props.row._original}
                title="Adições e Retiradas do Caixa"
                icon="import_export"
                tooltip
                tooltipInfo={{
                  dataTip: "Adições e Retiradas do Caixa",
                  dataFor: "import_export",
                  id: "import_export",
                  type: "dark",
                  effect: "float",
                  style: { maxHeight: 39, maxWidth: 39, marginLeft: 29 }
                }}
              />
            </Col>

            <Col xs={6} className="pl-0">
              <ViewDocumentButton
                repository={CashRegisterRepository}
                document={props.row._original}
                repositoryFunction={"getFile"}
                title="Fechamento de Caixa"
                icon="picture_as_pdf"
                tooltip
                tooltipInfo={{
                  dataTip: "Fechamento de Caixa",
                  dataFor: "picture_as_pdf",
                  id: "picture_as_pdf",
                  type: "dark",
                  effect: "float",
                  style: { maxHeight: 39, maxWidth: 39, marginRight: 29 }
                }}
              />
            </Col>
          </Row>
        );
      }
    }
  ]
};

class CashRegisterListView extends Component {
  render() {
    const { presenter, viewModel } = this.props;
    const { loading, filters, results, pagination, order } = viewModel;

    return (
      <Page>
        <Row>
          <Col xs={12} sm>
            <Typography type="display1" className="pb-sm">
              Histórico de Caixas
            </Typography>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Filter
              loading={loading}
              onFilter={filter => presenter.onFilterChange(filter)}
              filters={filters}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Loadable loading={loading}>
              <Paper elevation={1}>
                <DataTable
                  manual
                  filterable={false}
                  defaultSorted={[{ id: "opening_date", desc: true }]}
                  resultSet={results}
                  total={pagination.total}
                  perPage={pagination.perPage}
                  page={pagination.page}
                  config={config}
                  orderField={order.field}
                  orderDirection={order.direction}
                  onPageChange={page => presenter.onChangePage(page + 1)}
                  onChange={({ field, value }) =>
                    presenter.onChangeOrder({ field, direction: value })
                  }
                />
              </Paper>
            </Loadable>
          </Col>
        </Row>
      </Page>
    );
  }
}

export default CashRegisterListView;



// WEBPACK FOOTER //
// ./src/components/app/history/cash-register-reports/list/view.jsx